import { render, staticRenderFns } from "./scroll_image.vue?vue&type=template&id=10a8735a&scoped=true&"
import script from "./scroll_image.vue?vue&type=script&lang=js&"
export * from "./scroll_image.vue?vue&type=script&lang=js&"
import style0 from "./scroll_image.vue?vue&type=style&index=0&id=10a8735a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a8735a",
  null
  
)

export default component.exports